import React from "react";
import TeamCard from "./sub-componennts/TeamCard";

function Team() {
  const members = [
    {
      name: "Spriggs",
      designation: "Founder",
      description:
        "Spriggs will be fore-fronting the development of the project, this includes but is not limited to managing smart contracts, ensuring all development runs smoothly. From maintaining the website to providing new and unique utility for our community, Spriggs will be the lead dev within these en-devour.",
      profileImage:
        "https://thumbs.dreamstime.com/b/person-icon-black-background-person-solid-vector-eps-90447225.jpg",
    },
    {
      name: "Tembo",
      designation: "Founder",
      description:
        "Tembo holds a large amount of experience within the Crypto space. With Web 3.0 on the horizon, he chose the Solana Ecosystem to host our vision and to help project the urgency of saving the rhinos. With his experience in game development he will also be working alongside with a third party game developer to make sure the game is exactly what the community wants.",
      profileImage:
        "https://thumbs.dreamstime.com/b/person-icon-black-background-person-solid-vector-eps-90447225.jpg",
    },
    {
      name: "Moffia",
      designation: "Community Spokesman",
      description:
        "Moffia plays an important role of relationship building between all the teams such as contacting secondary markets and contacting influencers, most importantly will be direct liaison with the communities choice of charity.",
      profileImage:
        "https://thumbs.dreamstime.com/b/person-icon-black-background-person-solid-vector-eps-90447225.jpg",
    },
    {
      name: "Harry",
      designation: "Community Manager",
      description:
        "Harry will be a coordinator throughout the discord. He will be in charge of Community Management, with this role comes the responsibility of providing high quality features to the community while ensuring their safety.",
      profileImage:
        "https://thumbs.dreamstime.com/b/person-icon-black-background-person-solid-vector-eps-90447225.jpg",
    },
  ];
  return (
    <div className="bg-secondary">
      <>
        <h1
          id="team"
          className="xl:text-4xl text-3xl text-center text-primary font-extrabold py-6 sm:w-4/6 w-5/6 mx-auto  black-bruno"
        >
          Meet The Team
        </h1>
        <div className="w-full px-10 pt-10">
          <div className="container mx-auto">
            <div
              role="list"
              aria-label="Behind the scenes People "
              className="lg:flex md:flex sm:flex xl:justify-between flex-wrap md:justify-around sm:justify-around lg:justify-around"
            >
              {/* Member #1 */}
              {members.map((member) => {
                return (
                  <TeamCard
                    name={member.name}
                    designation={member.designation}
                    description={member.description}
                    profileImage={member.profileImage}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default Team;
